module.exports = __webpack_public_path__ + "img/status.70b04f11.svg";